<template>
<div v-if="is_load && reviews_data.length>0">
  <div class="col-12  mobile_div">
    <h2 class="text-center">Отзывы</h2>
  </div>
  <div class="row d-flex justify-content-center" v-if="reviews_data.length>1">
    <div class="col-6 d-flex justify-content-center ">
      <button class="btn" @click="toogleReview('prev')"><i class="fa fa-arrow-left"></i></button>
    </div>
    <div class="col-6 d-flex justify-content-center ">
      <button class="btn" @click="toogleReview('next')"><i class="fa fa-arrow-right"></i></button>
    </div>
  </div>
  <div class="row  mobile_div    d-flex justify-content-center  developer_block_review " v-if="current==review_index"  v-for="(review,review_index) in reviews_data">
    <div class="col-12  col-sm-4 col-md-2 block_avatar">

      <router-link class="d-flex justify-content-center" v-if="review.who.avatar"   tag="a"
          :to="{name: 'user_page_main', params: { user_id: review.who.last_id }}" ><v-lazy-image :src="image_url+review.who.avatar" class="mt-2 img img-thumbnail" v-if="review.who.avatar" /></router-link>


    </div>
    <div class="col-12  col-sm-8 col-md-8  review_data">
      <router-link v-if="review.who.avatar"   tag="a"
          :to="{name: 'user_page_main', params: { user_id: review.who.last_id }}" > <h3 class="client_name text-center">{{ review.who.name }}</h3></router-link>
      <p class="text-center">Оценка <span class="badge badge-circle badge-info ">{{ review.rating}}</span></p>
      <p class="text-center" v-if="review.items!=null && review.items && review.items.length>0">
        за товары: <router-link v-for="(item,item_index) in review.items"  tag="a"
          :to="{name: 'shop_item_id', params: {id:item.last_id  }}">{{ item.title}}</router-link>
      </p>
      <p  class="text-center" v-if="review.service && review.service.name">за услугу: <router-link  tag="a"
          :to="{name: 'service_page', params: {service_id:review.service.last_id  }}">{{ review.service.name}}</router-link></p>
      <editorjsrender :align_style="'center'"  :blocks_json="review.review.blocks"></editorjsrender>

      <p class="text-center" >{{ review.created_at }}  <router-link tag="a" :to="{name:'user_page_one_review',params:{user_id:review.user_id,id:review.last_id}}"><i class="fa fa-comments"></i> {{ review.comments_count }}</router-link></p>
    </div>





  </div>

</div>
</template>

<script>

import Editorjsrender from "@/models/Editorjsrender";
import VLazyImage from "v-lazy-image/v2";
import Vue from "vue";

export default {
  name: "ReviewWidget",
  props:{
    reviews:Array
  },
  components: {
    VLazyImage,
    'editorjsrender': Editorjsrender,
  },
  data(){
    return {
      'current':0,
      'image_url':null,
      'is_load':false,
      'reviews_data':[],
    };
  },
  mounted() {
    var app=this;
    app.reviews_data=app.reviews;
    app.image_url = Vue.config.IMAGE_URL;
    app.is_load=true;

  },
  methods:{
    toogleReview(type){
      var app=this;
      if(type=="next"){
        var next=app.current;
        next=next+1;
        if(!(next<=(app.reviews_data.length-1))){
          next=0;
        }
        app.current=next;
      }else if(type=="prev"){
        var prev=app.current;
        prev=prev-1;
        if(!(prev>=0)){
          prev=(app.reviews_data.length-1);
        }
        app.current=prev;
      }
    }
  }
}
</script>

<style scoped>

</style>